<template>
  <div>
    <h2>
      Historial Aumentos Salariales
    </h2>
    <el-card class="box-card">
      <div slot="header" class="d-flex space-between">
        <h4>Filtros</h4>
        <el-button size="mini" plain @click="showFilters = !showFilters">
          <i v-if="!showFilters" class="icon el-icon-arrow-down "></i>
          <i v-if="showFilters" class="icon el-icon-arrow-up "></i>
        </el-button>
      </div>
      <el-row :gutter="10" v-if="showFilters">
        <el-col :md="5">
          <h5>Compañía</h5>
          <el-select v-model="filters.company_id" placeholder="Selecciona una compañia" style="width: 100%;"
                     @change="getCompanyRelatedData()">
            <el-option
              v-for="item in companies"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="5">
          <h5>Centro de costo</h5>
          <el-select v-model="filters.cost_centers_id" placeholder="Selecciona un centro de costo" style="width: 100%;"
                     multiple @change="getEmployeesData()">
            <el-option
              v-for="item in cost_centers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="5">
          <h5>Empleado</h5>
          <el-select v-model="filters.employee_id" placeholder="Selecciona un empleado" style="width: 100%;"
                     multiple>
            <el-option
              v-for="item in employees"
              :key="item.id"
              :label="item.names +' '+ item.last_names"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <div :md="12">
          <h5>Fecha</h5>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="To"
            start-placeholder="fecha de inicio"
            end-placeholder="Fecha  final">
          </el-date-picker>
        </div>
      </el-row>
      <el-row :gutter="10" v-if="showFilters">
      </el-row>
      <el-row :gutter="10" style="margin-top: 20px">
        <el-col :md="24">
          <el-button type="danger" @click="cleanFilters()" :loading="loading" plain>Borrar Filtros</el-button>
          <el-button type="primary" @click="refreshData()" :loading="loading" plain>Filtrar</el-button>
        </el-col>
      </el-row>
    </el-card>
    <app-table
      @change-pagination="onChangePagination"
      @change-search="onChangeSearch"
      :total="total">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="employee_code"
          label="Cod">
        </el-table-column>
        <el-table-column
          prop="card"
          label="Identidad">
        </el-table-column>
        <el-table-column
          prop="names"
          label="Nombre">
          <template slot-scope="scope">
            <p>{{scope.row.names +' '+scope.row.last_names}}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="company"
          label="Compañía">
        </el-table-column>
        <el-table-column
          prop="cc"
          label="Centro de costos">
        </el-table-column>
        <el-table-column
          prop="old_salary"
          label="Salario anterior">
        </el-table-column>
        <el-table-column
          prop="new_salary"
          label="Salario nuevo">
        </el-table-column>
        <el-table-column
          prop="raise"
          label="Monto aumento">
        </el-table-column>
        <el-table-column
          prop="date"
          label="Fecha aumento">
        </el-table-column>
      </el-table>
    </app-table>
  </div>

</template>
<script>
  import AppTable from '../../components/Table'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {baseApi} from '../../configs/urls'
  import * as moment from 'moment'
  import {params, parseError} from '../../packages/Helpers'

  export default {
    extends: BaseCrud,
    name: 'salary-raise-report',
    components: {
      AppTable
    },
    data () {
      return {
        scope: null,
        date: [],
        cost_centers: [],
        companies: [],
        employees: [],
        filters: {
          cost_centers_id: [],
          company_id: [],
          employee_id: []
        },
        showFilters: true,
        methodForUpdate: 'post',
        baseUrl: baseApi + '/salary-increase-report',
        companyUrl: baseApi + '/companies',
        costCentersUrl: baseApi + '/cost-centers',
        basePermission: 'employees',
        employeesURL: baseApi + '/employees'
      }
    },
    methods: {
      companyData () {
        this.$http.get(this.companyUrl)
          .then(
            (res) => {
              this.companies = res.body
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
            }
          )
      },
      getCompanyRelatedData () {
        if (this.filters.company_id) {
          this.filters.cost_centers_id = []
          this.$http.get(this.costCentersUrl + '?company_id=' + this.filters.company_id)
            .then(
              (res) => {
                this.cost_centers = res.body
              },
              (res) => {
                if (res.status !== 0) {
                  this.$message.error(parseError(res)[0])
                }
              }
            )
          this.getEmployeesData()
        }
      },
      getEmployeesData () {
        if (this.filters.company_id > 0 && this.filters.cost_centers_id.length > 0) {
          const param = {
            pagination: 0,
            company_id: this.filters.company_id,
            cost_centers: this.filters.cost_centers_id
          }
          this.$http.get(this.employeesURL + params(param))
            .then(
              (res) => {
                this.employees = res.body
              },
              (res) => {
                if (res.status !== 0) {
                  this.$message.error(parseError(res)[0])
                }
              }
            )
        }
      },
      cleanFilters () {
        this.filters = {
          cost_centers_id: [],
          company_id: null,
          employee_id: []
        }
        this.date = []
        this.refreshData()
      },
      _beforeRefresh (params) {
        params.employee_id = this.filters.employee_id
        params.cost_center_id = this.filters.cost_centers_id
        params.company_id = this.filters.company_id
        if (this.date.length > 0) {
          params.init_date = moment(this.date[0]).format('YYYY-MM-DD:00:00:00')
          params.end_date = moment(this.date[1]).format('YYYY-MM-DD:23:59:59')
        }
      }
    },
    mounted () {
      this.companyData()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/reports/SalaryIncreaseReport.vue